import Vue from 'vue';
import Vuex from 'vuex';
import { LayoutModule } from './modules/layout-module';
// import { BetslipModule } from './modules/betslip-module';
import { SportsModule } from './modules/sports-module';
import { UpcomingModule } from './modules/upcoming-module';
import { HighlightsModule } from './modules/highlights-module';
import { favoritesModule } from './modules/favorites-module';
import { NegotiationsModule } from './modules/negotiations-module';
import { GlobalModule } from './modules/global-module';
import { StateWatcherPlugin } from './plugins/state-watcher-plugin';
// import { betslipMessagesModule } from './modules/betslip-messages-module';
import { cashoutModule } from './modules/cashout-module';
import { playerInfoModule } from './modules/player-info-module';
import { LiveStreamingModule } from './modules/live-streaming-module';
import { routeHistoryModule } from '../agent/store/route-history-module';
// import { betslipCombsModule } from './modules/betslip-combinations-module';
import { BsportsTrackerModule } from './modules/bsports-tracker-module';
// import { AccumulatorBonusesModule } from './modules/accumulator-bonuses-module';
import { UserModule } from './modules/user-module';
import { boostedOddsModule } from './modules/boosted-odds-module';

Vue.use(Vuex);
/**
 * Vuex store - documentation link: https://vuex.vuejs.org/en/
 */
export default new Vuex.Store({
  state: {},
  mutations: {
    toggleLoading(state, value) {
      state.loading = value;
    },
    toggleLazyLoad(state, value) {
      state.lazyLoading = value;
    },
  },
  actions: {},
  modules: {
    LayoutModule,
    // LiveMatchesModule,
    // BetslipModule,
    SportsModule,
    UpcomingModule,
    HighlightsModule,
    favoritesModule,
    NegotiationsModule,
    // betslipMessagesModule,
    GlobalModule,
    cashoutModule,
    playerInfoModule,
    LiveStreamingModule,
    routeHistoryModule,
    // betslipCombsModule,
    BsportsTrackerModule,
    // AccumulatorBonusesModule,
    UserModule,
    boostedOddsModule,
  },
  plugins: [StateWatcherPlugin],
  /**
   * @todo Disable strict mode for production as it is can run quite expensive computations
   */
  strict: process.env.NODE_ENV !== 'production',
});
